import { GET_SUCCESS_MESSAGE } from "../constants/actionTypes";

export const handleSuccessMessage = (successMessage) => {
  return {
    type: GET_SUCCESS_MESSAGE,
    payload: successMessage,
  };
};
